import {BaseSpringServiceCB} from '@aiknow-srl/aik-angular-sdk';
import {PaginatedCbI} from '../common/paginatedCbI';
import {PaginatedCbO} from '../common/paginatedCbO';
import {CustomerProductItemOPEEnum} from "../CustomerProductItem/CustomerProductItemOPEEnum";
import {ProductType} from "../../Models/CustomerProductItem/ProductType";
import {ProductTypeOPEEnum} from "./ProductTypeOPEEnum";
import {ProductItemChargerRelationDTO} from "../../Models/CustomerProductItem/ProductItemChargerRelationDTO";
import {ProductTypeChargerRelationDTO} from "./ProductTypeChargerRelationDTO";

export class ProductTypeDTO {
  public id!: number
  public name!: string;
  public ebike!: boolean;
  public moving!: boolean;
  public monitored!: boolean;

}

/**
 * I inner class
 */
class I {
  public productType!: ProductTypeDTO;
  public chargers!: ProductTypeChargerRelationDTO[];
}

/**
 * O inner class
 */

class O {}


/**
 * put reseller class
 */

export class PutProductTypeCB extends BaseSpringServiceCB {

  /**
   * I
   */
  public i: I;


  /**   * O
   */
  public o: O;


  /**
   * constructor
   */
  constructor(){
    super(ProductTypeOPEEnum.PutProductType);
    this.i = new I();
    this.o = new O();
  }

}
